import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { InputTextComponent } from '../../../../shared/components/input-text/input-text.component';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OrganizationApiService } from '../../../../core/services/organization-api.service';
import { MessageService } from 'primeng/api';
import { Organization } from '../../../../core/interfaces/organization';

@Component({
  selector: 'app-new-organization',
  imports: [ButtonModule, 
            TableModule, 
            DialogModule, 
            InputTextComponent, 
            ToastModule, 
            MultiSelectModule, 
            ReactiveFormsModule, 
            BlockUIModule,
            ProgressSpinnerModule],
  providers: [],
  templateUrl: './new-organization.component.html',
  styleUrl: './new-organization.component.scss'
})
export class NewOrganizationComponent {

  blockedDocument = false;
  @Input() visible!: boolean;
  @Output() closeDialog = new EventEmitter();

  organizationForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)])   
  });

  constructor(private organizationApi: OrganizationApiService, private messageService: MessageService) {

  }

  loadData() {
    this.organizationForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)])   
    });   
  }


  close() {
      this.closeDialog.emit("")
  }

  save() {
    if (this.organizationForm.valid) {
     const organization: Organization = this.organizationForm.value as Organization
     this.blockedDocument = true;
     this.organizationApi.createOrganization(organization).subscribe({
        next: (data) =>{
          this.blockedDocument = false;
          this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Organization was succesfully updated.' })
          this.close()
        } ,
        error: (err) => {
          this.blockedDocument = false;
          console.error('Error fetching data', err)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'A problem occurred during the user update.', life: 5000 })

        }
     })
    } else {
        this.organizationForm.markAllAsTouched();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please, verify the required fields.', life: 5000 })

    }
  }
}
